import { render } from "./SubTitle2.vue?vue&type=template&id=a1d11f44&scoped=true"
import script from "./SubTitle2.vue?vue&type=script&lang=js"
export * from "./SubTitle2.vue?vue&type=script&lang=js"

import "./SubTitle2.vue?vue&type=style&index=0&id=a1d11f44&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d11f44"]])

export default __exports__